"use strict";
var contains = function(field, text) {
  if (!text)
    return true;
  else if (field && field.indexOf(text) != -1)
    return true;
  else
    return false;
};
var tableCtrl = function() {
  function tableCtrl($http, $scope, service, $uibModal) {
    var $__2 = this;
    this.$http = $http;
    this.$uibModal = $uibModal;
    this.pagesize = 25;
    this.allSelected = false;
    this.selectedCount = 0;
    this.searchFilter = "";
    this.doctypeFilter = "";
    this.service = service;
    this.update(service.lines);
    $scope.$watch(function() {
      return service.lines;
    }, function() {
      $__2.update(service.lines);
    });
    $scope.$watch(function() {
      return $__2.allSelected;
    }, function() {
      $__2.selectAll();
    });
    $scope.$watch(function() {
      return $__2.searchFilter;
    }, function() {
      $__2.update(service.lines);
    });
    $scope.$watch(function() {
      return $__2.doctypeFilter;
    }, function() {
      $__2.update(service.lines);
    });
  }
  return ($traceurRuntime.createClass)(tableCtrl, {
    update: function(lines) {
      var $__2 = this;
      this.lines = this.needFilter() ? _.filter(lines, function(line) {
        return $__2.filterFunc(line);
      }) : lines;
      this.page = 1;
      this.maxpage = Math.trunc(this.lines.length / this.pagesize);
      this.updateSelectAll();
    },
    confirm: function() {
      var $__2 = this;
      this.showConfirmationDialog("Wollen Sie wirklich alle Dokumentänderungen übernehmen?").then(function() {
        $__2.service.confirm($__2.selectedLines());
      });
    },
    revert: function() {
      var $__2 = this;
      this.showConfirmationDialog("Wollen Sie wirklich alle Dokumentänderungen rückgängig machen?").then(function() {
        $__2.service.revert($__2.selectedLines());
      });
    },
    showConfirmationDialog: function(msg) {
      return this.$uibModal.open({
        templateUrl: 'confirmation/templates/confirm.ng.html',
        controller: ['$scope', function($scope) {
          $scope.confirmMessage = msg;
        }]
      }).result;
    },
    selectedLines: function() {
      return _.filter(this.service.lines, function(line) {
        return line.selected;
      });
    },
    needFilter: function() {
      if (!this.searchFilter && !this.doctypeFilter)
        return false;
      else
        return true;
    },
    filterFunc: function(line) {
      return this.filterSearchText(line) && this.filterDocumentType(line);
    },
    filterDocumentType: function(line) {
      if (!this.doctypeFilter)
        return true;
      return line.typ == this.doctypeFilter;
    },
    filterSearchText: function(line) {
      if (!this.searchFilter)
        return true;
      if (contains(line.archivNr, this.searchFilter))
        return true;
      if (contains(line.name, this.searchFilter))
        return true;
      if (contains(line.descriptionName, this.searchFilter))
        return true;
      if (contains(line.author, this.searchFilter))
        return true;
      return false;
    },
    selectAll: function() {
      if (this.allSelected == null)
        return;
      for (var i = 0; i < this.lines.length; ++i) {
        this.lines[i].selected = this.allSelected;
      }
      this.updateSelectCount();
    },
    updateSelectAll: function() {
      this.updateSelectCount();
      var someSelected = this.selectedCount > 0;
      var allSelected = this.selectedCount == this.lines.length;
      this.allSelected = !someSelected ? false : (allSelected ? true : null);
    },
    updateSelectCount: function() {
      var count = 0;
      for (var i = 0; i < this.lines.length; ++i) {
        if (this.lines[i].selected)
          count++;
      }
      this.selectedCount = count;
    }
  }, {});
}();
;
tableCtrl.$inject = ['$http', '$scope', 'dataService', '$uibModal'];
module.exports = tableCtrl;
